import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, ModalOpen, StateManager, useBCMSContext, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import { UICancelButton, UIPrimaryButton } from 'components/ui/UIButton';
import UIShowHideInput from 'components/ui/UIShowHideInput';
import UITextInput from 'components/ui/UITextInput';
import Classes, { CardOnFileMerchant, RecurringPaymentMerchant } from "model";
import React from 'react';
import { ImageAsset } from 'res';
import VerificationProgressWidget from '../widgets/VerificationProgressWidget';
import "./styles.css";

/**
 * @function VerificationEnterCredsView
 * @return {React.Component}
 * @exported true
 * @description The component that shows the enter credentials for verification
 */

export default function VerificationEnterCredsView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  // Get the card id from the parameter
  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const { goStep, nextStep } = useWorkflow() ?? {};
  const navigate = useRoute();

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: (prop, val) => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], val)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    next: () => {
      if(nextStep) {
        nextStep({ data, ui });
      } else {
        navigate("/home/verification/securitycode");
      }
    },

    cancel: () => {
      let clearedMerchant = undefined;
      if(data.cardOnFileSelectedTabType === "recurring") {
        clearedMerchant = RecurringPaymentMerchant.getClearedRecurringPaymentMerchant(data.cardOnFileMerchant);
      } else {
        clearedMerchant = CardOnFileMerchant.getClearedCardOnFileMerchant(data.cardOnFileMerchant);
      }
      data.cardOnFileMerchant = clearedMerchant;
      goStep(2, { data, ui });
    },

    updateTextInput: type => val => {
      const crud = BCMSStateManagerCRUD.init(state)
      .update([ "data", "cardOnFileMerchant", type ], val);

      crud.update([ "ui" ], ui)
      .submit(setState);
    },
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = () => {
  const cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();

  return {
    cardOnFileMerchant,
    revealPassword: false
  }
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui, cancel, next, update, updateTextInput } = useStateManager();
  const merchant = data.cardOnFileMerchant.merchant ?? {};
  const merchantName = props.merchantName ?? "[[MerchantName]]";
  const merchantLogo = props.merchantLogo ?? <><ImageAsset id={ merchant.logo } className="transaction-logo" /></>;
  const onShowHideClick = val => update("revealPassword", !val);
  const enableSubmitButton = data.cardOnFileMerchant.verificationMerchantUsername.length > 0 
  && data.cardOnFileMerchant.verificationMerchantPassword.length > 0;

  return (
    <div className="verification-enter-creds-view verification-view">
      <VerificationProgressWidget className="active" />
      <p>Linking Account</p>
      <div className="account-container">
        <div className="header-container flex-container flex-horizontal align-center-container bottom-border">
          <div className="set-width img-container">
            {merchantLogo}
          </div>
          <p className="flex-width">{ merchant.name }</p>
        </div>
        <FormContainer>
          <FormRow>
            <UITextInput placeholder="Username" value={ data.cardOnFileMerchant.verificationMerchantUsername }
             onChange={ updateTextInput("verificationMerchantUsername") } />
          </FormRow>
          <FormRow>
            <UIShowHideInput revealPassword={ data.revealPassword } placeholder="Password" value={ data.cardOnFileMerchant.verificationMerchantPassword } 
            onChange={ updateTextInput("verificationMerchantPassword") } onShowHideClick={ onShowHideClick } />
          </FormRow>
          <FormButtonContainer>
            <UIPrimaryButton text="Submit" className={ enableSubmitButton ? "" : "disabled" } onClick={ next } />
            <ModalOpen id="CancelUpdateMerchantModal" data={ { onConfirmClick: cancel } }>
              <UICancelButton text="Cancel" />
            </ModalOpen>
          </FormButtonContainer>
        </FormContainer>
      </div>
    </div>
  );
}